export const ROOM_STATUS = {
    NotObtained: 1, // 该房间还未获取坐标点
    Obtained: 2, // 房间已获取坐标点
}
